/**
 * Created by Stefano Mandruzzato on 20/11/18.
 */

import ExternalHeaderController from './external-header.controller';

const ExternalHeaderComponent = {
  bindings: {},
  template: require('./external-header.html'),
  controller: ExternalHeaderController
};


export default ExternalHeaderComponent;



// WEBPACK FOOTER //
// ./client/app/layout/external-layout/external-header/external-header.component.js